module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form class=\"input-group search-bar\"> <input type=\"text\" class=\"form-control form-control-lg border-0 py-2 px-0 px-sm-3\" placeholder=\"")
    ; __append(escapeFn( locals.placeholder ))
    ; __append("\"> <button class=\"btn btn-secondary pull-right\" type=\"submit\">Search</button> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/list/search/template.ejs
// module id = 1241
// module chunks = 1